import { http } from '@/lib/axios';
import { unwrap, toApiError } from '@/lib/unwrap';
import type { ApiEnvelope } from '@/types/api';

export interface PrintTicketStatus {
  id: string;
  status: 'PRINTED' | 'FAILED' | 'PENDING' | string;
  message?: string;
}

export interface PrintBatchResult {
  invoiceId: string;
  tickets: PrintTicketStatus[];
}

export async function printBatch(invoiceId: string): Promise<PrintBatchResult> {
  try {
    const res = await http.post<ApiEnvelope<PrintBatchResult>>(
      `/qr-code/print-batch/${invoiceId}`,
      {},
    );
    return unwrap(res.data);
  } catch (error) {
    throw toApiError(error);
  }
}

export async function printSingle(qrId: string): Promise<PrintTicketStatus> {
  try {
    const res = await http.post<ApiEnvelope<PrintTicketStatus>>(`/qr-code/print/${qrId}`, {});
    return unwrap(res.data);
  } catch (error) {
    throw toApiError(error);
  }
}
